import axios from "axios";
import { useEffect, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const money = (m) =>
  m?.amount
    ? new Intl.NumberFormat("en-US", { style: "currency", currency: m.currencyCode, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(m.amount))
    : "";

export const sized = (url, w) => (url ? `${url}${url.includes("?") ? "&" : "?"}width=${w}` : "");

export const productImages = (p) => (Array.isArray(p?.images?.nodes) ? p.images.nodes : []);

export const isNew = (p) =>
  (p?.tags || []).some((t) => t.toLowerCase() === "new") ||
  (p?.createdAt && Date.now() - new Date(p.createdAt).getTime() < 1000 * 60 * 60 * 24 * 30);

export function useApi(path) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState({ data: null, loading: true, error: null });
    api
      .get(path)
      .then((r) => { if (alive) setState({ data: r.data, loading: false, error: null }); })
      .catch((e) => { if (alive) setState({ data: null, loading: false, error: e?.response?.data?.detail || "Unavailable" }); });
    return () => { alive = false; };
  }, [path]);
  return state;
}
